// Babyworks by Swapnil — Rakhi Landing Page
// File: assets/rakhi-page.js

document.addEventListener('DOMContentLoaded', function () {

  // ── Hero slideshow: autoplay + dots + arrows + swipe ──
  var heroSlides = document.querySelectorAll('#rkHeroSlides .rk-hero-slide');
  var heroDots = document.querySelectorAll('#rkHeroDots .rk-hero-dot');
  var heroPrev = document.getElementById('rkHeroPrev');
  var heroNext = document.getElementById('rkHeroNext');

  if (heroSlides.length > 1) {
    var heroIndex = 0;
    var heroTimer = null;
    var heroIntervalMs = 4500;

    var heroCaption = document.getElementById('rkHeroCaption');
    var heroCaptionLine1 = document.getElementById('rkHeroCaptionLine1');
    var heroCaptionLine2 = document.getElementById('rkHeroCaptionLine2');

    var showHeroSlide = function (i) {
      heroIndex = (i + heroSlides.length) % heroSlides.length;
      heroSlides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === heroIndex); });
      heroDots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === heroIndex); });
      var activeSlide = heroSlides[heroIndex];
      if (heroCaptionLine1) heroCaptionLine1.textContent = activeSlide.getAttribute('data-caption-line1') || '';
      if (heroCaptionLine2) heroCaptionLine2.textContent = activeSlide.getAttribute('data-caption-line2') || '';
      if (heroCaption) {
        var pos = activeSlide.getAttribute('data-caption-pos') || '0';
        heroCaption.classList.remove('rk-hero-caption--pos0', 'rk-hero-caption--pos1', 'rk-hero-caption--pos2', 'rk-hero-caption--pos3');
        heroCaption.classList.add('rk-hero-caption--pos' + pos);
      }
    };

    var startHeroAutoplay = function () {
      if (heroTimer) clearInterval(heroTimer);
      heroTimer = setInterval(function () { showHeroSlide(heroIndex + 1); }, heroIntervalMs);
    };

    heroDots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () {
        showHeroSlide(idx);
        startHeroAutoplay();
      });
    });
    if (heroPrev) {
      heroPrev.addEventListener('click', function () { showHeroSlide(heroIndex - 1); startHeroAutoplay(); });
    }
    if (heroNext) {
      heroNext.addEventListener('click', function () { showHeroSlide(heroIndex + 1); startHeroAutoplay(); });
    }

    var heroEl = document.querySelector('.rk-hero');
    var touchStartX = 0;
    if (heroEl) {
      heroEl.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      heroEl.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) {
          showHeroSlide(dx < 0 ? heroIndex + 1 : heroIndex - 1);
          startHeroAutoplay();
        }
      }, { passive: true });
    }

    startHeroAutoplay();
  }

  // ── Product carousels: desktop arrow scroll + drag-to-scroll (reusable) ──
  function setupProductCarousel(gridId, prevId, nextId) {
    var grid = document.getElementById(gridId);
    var prevBtn = document.getElementById(prevId);
    var nextBtn = document.getElementById(nextId);
    if (!grid) return;

    var scrollAmount = function () {
      var card = grid.querySelector('.rk-pc');
      return card ? card.offsetWidth + 12 : 240;
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        grid.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        grid.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }

    // Desktop drag-to-scroll and wheel support
    var isDown = false, startX, scrollLeft;

    grid.addEventListener('mousedown', function (e) {
      isDown = true;
      grid.classList.add('is-dragging');
      startX = e.pageX - grid.offsetLeft;
      scrollLeft = grid.scrollLeft;
    });
    grid.addEventListener('mouseleave', function () { isDown = false; grid.classList.remove('is-dragging'); });
    grid.addEventListener('mouseup', function () { isDown = false; grid.classList.remove('is-dragging'); });
    grid.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - grid.offsetLeft;
      var walk = (x - startX) * 1.2;
      grid.scrollLeft = scrollLeft - walk;
    });
    grid.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        grid.scrollLeft += e.deltaY;
        e.preventDefault();
      }
    }, { passive: false });
  }

  setupProductCarousel('rkHathphoolPgrid', 'rkHathphoolPrev', 'rkHathphoolNext');
  setupProductCarousel('rkKurtaPgrid', 'rkKurtaPrev', 'rkKurtaNext');

  // ── UGC ticker: continuous loop by duplicating cards ──
  var ugcTrack = document.getElementById('rkUgcTrack');
  if (ugcTrack && ugcTrack.children.length > 0) {
    var originalCards = Array.prototype.slice.call(ugcTrack.children);
    originalCards.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      ugcTrack.appendChild(clone);
    });

    var ugcPos = 0;
    var ugcSpeed = 0.4; // px per frame
    var ugcPaused = false;

    ugcTrack.addEventListener('mouseenter', function () { ugcPaused = true; });
    ugcTrack.addEventListener('mouseleave', function () { ugcPaused = false; });

    function tickUgc() {
      if (!ugcPaused) {
        ugcPos -= ugcSpeed;
        var resetPoint = -(ugcTrack.scrollWidth / 2);
        if (ugcPos <= resetPoint) ugcPos = 0;
        ugcTrack.style.transform = 'translateX(' + ugcPos + 'px)';
      }
      requestAnimationFrame(tickUgc);
    }
    requestAnimationFrame(tickUgc);
  }

  // ── Press strip: continuous loop (logos already duplicated in Liquid) ──
  var pressTrack = document.getElementById('rkPressTrack');
  if (pressTrack) {
    var pressPos = 0;
    var pressSpeed = 0.5;
    function tickPress() {
      pressPos -= pressSpeed;
      var resetPoint = -(pressTrack.scrollWidth / 2);
      if (pressPos <= resetPoint) pressPos = 0;
      pressTrack.style.transform = 'translateX(' + pressPos + 'px)';
      requestAnimationFrame(tickPress);
    }
    requestAnimationFrame(tickPress);
  }

  // ── FAQ accordion ──
  var faqItems = document.querySelectorAll('.rk-faq-item');
  faqItems.forEach(function (item) {
    var q = item.querySelector('.rk-faq-q');
    if (!q) return;
    q.addEventListener('click', function () {
      var wasOpen = item.classList.contains('is-open');
      faqItems.forEach(function (i) { i.classList.remove('is-open'); });
      if (!wasOpen) item.classList.add('is-open');
    });
  });

  // ── Sticky mobile CTA: show after hero is scrolled past ──
  var stickyCta = document.getElementById('rkStickyCta');
  var hero = document.querySelector('.rk-hero');
  if (stickyCta && hero) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyCta.classList.remove('is-visible');
        } else {
          stickyCta.classList.add('is-visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(hero);
  }

});